var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1L12.4334 6.65067L18.5595 7.21885L13.9374 11.2793L15.2901 17.2812L10 14.14L4.70993 17.2812L6.06263 11.2793L1.44049 7.21885L7.56657 6.65067L10 1Z",
    stroke: "#3DA3BA",
    strokeWidth: 1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.0c8408c9d3bca7cc69e7e32994ea0b57.svg";
export { ForwardRef as ReactComponent };